module.exports = __webpack_public_path__ + "static/contact-banner-0e3f84007f76687ef9da9b0bd1998cf6.jpg";